import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { durationSecToStr } from '../tracking-format.util';
import type { DashboardMetrics } from '../tracking-demo.models';

/** The 8 live metric tiles across the top of the dashboard. */
@Component({
  selector: 'app-session-metrics',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-8 gap-3">
      @for (t of tiles(); track t.label) {
        <div class="rounded-xl border border-[#EAEAEA] dark:border-line bg-white dark:bg-surface-1 p-3">
          <div class="text-[11px] font-medium text-gray-500 dark:text-gray-400">{{ t.label }}</div>
          <div class="mt-1 text-xl font-semibold" [class]="t.accent">{{ t.value }}</div>
        </div>
      }
    </div>
  `,
})
export class SessionMetricsComponent {
  @Input() metrics: DashboardMetrics | null = null;

  tiles(): { label: string; value: string | number; accent: string }[] {
    const m = this.metrics;
    return [
      { label: 'Active Sessions', value: m?.activeSessions ?? 0, accent: 'text-emerald-600 dark:text-emerald-400' },
      { label: "Today's Sessions", value: m?.todaySessions ?? 0, accent: 'text-sky-600 dark:text-sky-400' },
      { label: 'Blocked IPs', value: m?.blockedIps ?? 0, accent: 'text-red-600 dark:text-red-400' },
      { label: 'Total Participants', value: m?.totalParticipants ?? 0, accent: 'text-indigo-600 dark:text-indigo-400' },
      { label: 'Avg Duration', value: durationSecToStr(m?.avgDemoDurationSec ?? 0), accent: 'text-gray-800 dark:text-gray-100' },
      { label: 'Successful Demos', value: m?.successfulDemos ?? 0, accent: 'text-emerald-600 dark:text-emerald-400' },
      { label: 'Rejected Guests', value: m?.rejectedGuests ?? 0, accent: 'text-orange-600 dark:text-orange-400' },
      { label: 'Disconnected', value: m?.disconnectedSessions ?? 0, accent: 'text-red-600 dark:text-red-400' },
    ];
  }
}
